import moment from 'moment'
import React from 'react'

function formatAmount(value) {
  if (value === null || value === undefined || value === '') {
    return ''
  }
  return new Intl.NumberFormat('vn-VI', {}).format(value)
}

export function MoneyLogCell({ moneyLog, expectedType, expectedId }) {
  if (!moneyLog) {
    return <td className="text-warning">Chưa gắn dòng tiền</td>
  }
  const mismatch = (expectedId && moneyLog.ref !== expectedId) || (expectedType && moneyLog.type !== expectedType)
  const when = moneyLog.createdAt ? moment(moneyLog.createdAt).format('DD/MM/YYYY HH:mm') : ''
  return (
    <td>
      <div className="fw-900">{formatAmount(moneyLog.commitedAmount)}</div>
      <div className="small">{when}</div>
      <div className="small text-break">{moneyLog.description || ''}</div>
      {mismatch ? <div className="text-danger">Gắn nhầm dòng tiền</div> : null}
    </td>
  )
}

export function MoneyLogLines({ logs }) {
  const rows = (logs || []).filter(Boolean)
  if (rows.length === 0) {
    return <div className="text-warning">Chưa gắn dòng tiền</div>
  }
  return (
    <>
      {rows.map((item, index) => (
        <div key={item.id || index} className="mb-2">
          <div><strong>{item.label || 'Dòng tiền'}</strong> {formatAmount(item.commitedAmount)}</div>
          <div className="small">{item.createdAt ? moment(item.createdAt).format('DD/MM/YYYY HH:mm:ss') : ''}</div>
          <div className="small text-break">{item.description || ''}</div>
          {item.mismatch ? <div className="text-danger">Gắn nhầm dòng tiền</div> : null}
        </div>
      ))}
    </>
  )
}
